import { getLocalStorage } from "@/utils/storage"

const en = {
  'page_login_login_by_phone': 'Password free login',
  'page_login_login_by_pwd': 'Password login',
  'page_login_tenant': 'Company',
  'please_select': 'please select',
  'common_please_input':'please input',
  'page_login_tenant_tip': 'Please enter company name!',
  'page_login_tenant_tip2': 'Please enter company name first!',
  'page_login_username': 'Account',
  'page_login_username_tip': 'Please enter account!',
  'page_login_password': 'Password',
  'page_login_password_tip': 'Please enter password!',
  'page_login_socialId': 'Phone number',
  'page_login_socialId_tip': 'Please enter phone number!',
  'page_login_socialId_err_tip': 'Please enter the correct phone number!',
  'page_login_code': 'Verification Code',
  'page_login_code_tip': 'Please enter the verification code!',
  'page_login_btn': 'Login',
  'page_login_btnText1': 'Verification code',
  'page_login_btnText2': 'Resend in {0}s',
  'page_login_alert': 'We will send an email to your mailbox, please open the link in the email to change your password!',
  'page_login_back': 'Back',
  'page_login_send': 'Send',
  "page_personal_email": "Email",
  "page_personal_please_enter_email": "Please enter email",
  "page_personal_please_enter_correct_email": "Please enter correct email",
}

const cn = {
  'page_login_login_by_phone': '免密登录',
  'page_login_login_by_pwd': '密码登录',
  'page_login_tenant': '公司',
  'please_select': '请选择',
  'common_please_input':'请输入',
  'page_login_tenant_tip': '请输入公司名称!',
  'page_login_tenant_tip2': '请先输入公司名称!',
  'page_login_username': '账户',
  'page_login_username_tip': '请输入账户!',
  'page_login_password': '密码',
  'page_login_password_tip': '请输入密码!',
  'page_login_socialId': '手机号',
  'page_login_socialId_tip': '请输入手机号!',
  'page_login_socialId_err_tip': '请输入正确的手机号!',
  'page_login_code': '验证码',
  'page_login_code_tip': '请输入验证码!',
  'page_login_btn': '登录',
  'page_login_btnText1': '获取验证码',
  'page_login_btnText2': '{0}秒后重发',
  'page_login_alert': '我们将向您的邮箱发送一封邮件，请打开邮件内的链接修改密码！',
  'page_login_back': '返回',
  'page_login_send': '发送',
  "page_personal_email": "邮箱",
  "page_personal_please_enter_email": "请输入邮箱",
  "page_personal_please_enter_correct_email": "请输入正确的邮箱",
}

export const getLang = (key) => {
  return getLocalStorage('lang') && getLocalStorage('lang') === 'en_US' ? en[key] : cn[key]
}
